<template>
  <q-dialog ref="dialogRef"
            @hide="onDialogHide">
    <q-card>
      <q-card-section class="q-pa-lg">
        <div class="text-h6">{{title}}</div>
      </q-card-section>

      <q-card-section class="q-pt-none q-pl-lg q-pr-lg q-pb-lg">
        {{body}}
      </q-card-section>

      <q-card-actions align="right"
                      class="q-pa-lg">
        <q-btn flat
               color="primary"
               :label="cancelLabel"
               @click="onCancelClick" />
        <q-btn color="primary"
               :label="okLabel"
               @click="onOKClick" />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { useDialogPluginComponent } from 'quasar';

export default {
  props: {
    okLabel: {
      type: String,
      default: 'Confirm',
    },
    cancelLabel: {
      type: String,
      default: 'Cancel',
    },
    title: String,
    body: String,
  },
  emits: [
    // REQUIRED; need to specify some events that your
    // component will emit through useDialogPluginComponent()
    ...useDialogPluginComponent.emits,
  ],
  setup() {
    // REQUIRED; must be called inside of setup()
    const {
      dialogRef, onDialogHide, onDialogOK, onDialogCancel,
    } = useDialogPluginComponent();

    return {
      // This is REQUIRED;
      // Need to inject these (from useDialogPluginComponent() call)
      // into the vue scope for the vue html template
      dialogRef,
      onDialogHide,

      onOKClick: onDialogOK,
      onCancelClick: onDialogCancel,
    };
  },
};
</script>
